import React from 'react';
import PropTypes from 'prop-types';
// import Link from 'components/Link';

import s from './NoticeBoard.scss';
import ReadMoreLess from '../ReadMoreLess/ReadMoreLess';
import ReadableTimeStamp from '../ReadableTimeStamp/ReadableTimeStamp';

const NoticeBoardItem = props => {
  const { boardItem, index, isWapView, ga4Type = '' } = props;
  const {
    title = '',
    description = '',
    overridelink = '',
    timestamp = 0,
    hoverridLink = '',
    updateDate = 0,
    showTimeStamp = false,
  } = boardItem;

  return (
    <>
      <div className={s.textNodeWrap}>
        <span className={`${!description ? s.fullText : ''}`}>{title}</span>
        <ReadMoreLess
          information={description}
          readMoreLengthLimit={isWapView ? 100 : 300}
          readMoreOnly
          link={overridelink || hoverridLink}
          ga4Type={ga4Type}
          index={index}
          ga4Params={
            !!ga4Type && {
              event: 'user_click',
              type: ga4Type,
              story_no: index,
            }
          }
        />
      </div>
      <div className={s.nbBottomWrap}>
        {showTimeStamp && (
          <ReadableTimeStamp timestamp={timestamp} updateDate={updateDate} />
        )}
        {/* {(overridelink || hoverridLink) && (
          <Link
            to={overridelink || hoverridLink}
            ga4Data={
              !!ga4Type && [
                {
                  event: 'user_click',
                  type: ga4Type,
                  label: 'read_full_story',
                  story_no: index,
                },
              ]
            }
          >
            FULL STORY
          </Link>
        )} */}
      </div>
    </>
  );
};

NoticeBoardItem.propTypes = {
  boardItem: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    overridelink: PropTypes.string,
    timestamp: PropTypes.number,
    updateDate: PropTypes.number,
    msid: PropTypes.number,
  }),
  index: PropTypes.number,
  ga4Type: PropTypes.string,
};

NoticeBoardItem.defaultProps = {
  boardItem: {
    title: '',
    description: '',
    overridelink: '',
    timestamp: 0,
    updateDate: 0,
    msid: 0,
  },
  index: 0,
  ga4Type: '',
};

export default NoticeBoardItem;
